module.exports = __webpack_public_path__ + "img/xxsj.15b3c0cd.png";